import React from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { isEmpty, trim } from 'lodash';
import { PrintOptions } from '../../shared/footerView';
import { togglePswd } from '../../modules/utils';

const IntegrationFileds = [
  { id: 'platform', displayLabel: 'Platform Name', fieldType: 'select' },
  { id: 'url', displayLabel: 'URL', fieldType: 'input' },
  { id: 'userName', displayLabel: 'User Name', fieldType: 'input' },
  { id: 'password', displayLabel: 'Password', fieldType: 'password' }
];
const DefectFileds = [
  { id: 'platform', displayLabel: 'Platform Name', fieldType: 'select' },
  { id: 'url', displayLabel: 'URL', fieldType: 'input' },
  { id: 'userName', displayLabel: 'User Name', fieldType: 'input' },
  { id: 'password', displayLabel: 'Password', fieldType: 'password' },
  { id: 'projectName', displayLabel: 'Project Name', fieldType: 'input' }
];
const IntFileds = [
  { id: 'dbName', displayLabel: 'DB Name', fieldType: 'select' },
  { id: 'ipAdd', displayLabel: 'IP Address', fieldType: 'input' },
  { id: 'userName', displayLabel: 'User Name', fieldType: 'input' },
  { id: 'password', displayLabel: 'Password', fieldType: 'password' }
];

export const integrationView = (props) => {
  const {
    onChange,
    selected,
    resetValues,
    onSelectChange,
    onSaveClick,
    jiraCheck
  } = props;
  const { platform, url, userName, dbName, password, ipAdd, projectName } =
    selected;
  const disableIntButton =
    isEmpty(trim(platform)) ||
    isEmpty(trim(url)) ||
    isEmpty(trim(userName)) ||
    isEmpty(trim(password));
  const disableDefectButton =
    isEmpty(trim(platform)) ||
    isEmpty(trim(url)) ||
    isEmpty(trim(userName)) ||
    isEmpty(trim(password)) ||
    isEmpty(trim(projectName));
  const disableDBButton =
    isEmpty(trim(dbName)) ||
    isEmpty(trim(ipAdd)) ||
    isEmpty(trim(userName)) ||
    isEmpty(trim(password));
  const printField = ({
    fieldType,
    id,
    onChange,
    props,
    option,
    toggleEye
  }) => {
    let elementProps = {
      className: `form-control`,
      value: selected[id],
      onChange: (e) => onChange({ id, value: e.currentTarget.value })
    };

    switch (fieldType) {
      case 'input':
        return <input type='text' {...elementProps} />;
      case 'password':
        return (
          <>
            <input type='password' id={option} {...elementProps} />
            <span
              id={toggleEye}
              onClick={(eve) => togglePswd(eve, option)}
              className='fa fa-fw fa-eye pswd-toggle'
            ></span>
          </>
        );
      case 'date':
        return <input type='date' {...elementProps} />;
      case 'select':
        return (
          <select
            onChange={(eve) =>
              onSelectChange({ id, val: eve.currentTarget.value })
            }
            className='form-select'
            dataContainer='body'
          >
            <PrintOptions value={selected[id]} options={props[option]} />
          </select>
        );
      default:
        return null;
    }
  };
  return (
    <div className='page--superAdmin'>
      <div key={'Integration_view'} className='testsuiteDetail__row'></div>
      <Tabs
        defaultActiveKey='Requirement Management'
        id='justify-tab-example'
        onSelect={(val) => resetValues(val)}
        className='mb-3'
        justify
      >
        <Tab
          eventKey='Requirement Management'
          title='Requirement Management'
          className='mt-5'
        >
          {IntegrationFileds.map((field) => {
            const { fieldType, displayLabel, id } = field;
            return (
              <div key={field.id} className='row mt-3'>
                <label className='col-sm-2 col-form-label'>
                  {id === 'password' && jiraCheck ? 'Token Key' : displayLabel}
                </label>
                <div className='col-sm-4'>
                  {printField({
                    fieldType,
                    id,
                    selected,
                    onChange,
                    props,
                    toggleEye: 'togglePswd1',
                    option: 'requirementOption'
                  })}
                </div>
                <div className='col-sm-4'></div>
              </div>
            );
          })}
          <div className='mt-4'>
            <button
              type='button'
              onClick={(e) => {
                onSaveClick(e, 'Requirement Management');
              }}
              className={`btn btn--small btn--default`}
              disabled={disableIntButton}
            >
              Save
            </button>
            <button
              type='button'
              // onClick={() => onCancelClick("customer")}
              className='btn btn--small btn--cancel'
            >
              Cancel
            </button>
          </div>
        </Tab>
        <Tab
          eventKey='Defect Management'
          title='Defect Management'
          className='mt-5'
        >
          {DefectFileds.map((field) => {
            const { fieldType, displayLabel, id } = field;
            return (
              <div key={field.id} className='row mt-3'>
                <label className='col-sm-2 col-form-label'>
                  {id === 'password' && jiraCheck ? 'Token Key' : displayLabel}
                </label>
                <div className='col-sm-4'>
                  {printField({
                    fieldType,
                    id,
                    selected,
                    onChange,
                    props,
                    toggleEye: 'togglePswd2',
                    option: 'defectOption'
                  })}
                </div>
              </div>
            );
          })}
          <div className='mt-4'>
            <button
              type='button'
              onClick={(e) => {
                onSaveClick(e, 'Defect Management');
              }}
              className={`btn btn--small btn--default`}
              disabled={disableDefectButton}
            >
              Save
            </button>
            <button
              type='button'
              // onClick={() => onCancelClick("customer")}
              className='btn btn--small btn--cancel'
            >
              Cancel
            </button>
          </div>
        </Tab>
        <Tab eventKey='CI/CD' title='CI/CD' className='mt-5'>
          {IntegrationFileds.map((field) => {
            const { fieldType, displayLabel, id } = field;
            return (
              <div key={field.id} className='row mt-3'>
                <label className='col-sm-2 col-form-label'>
                  {displayLabel}
                </label>
                <div className='col-sm-4'>
                  {printField({
                    fieldType,
                    id,
                    selected,
                    onChange,
                    props,
                    toggleEye: 'togglePswd3',
                    option: 'cicdOption'
                  })}
                </div>
              </div>
            );
          })}
          <div className='mt-4'>
            <button
              type='button'
              onClick={(e) => {
                onSaveClick(e, 'CI/CD');
              }}
              className={`btn btn--small btn--default`}
              disabled={disableIntButton}
            >
              Save
            </button>
            <button
              type='button'
              // onClick={() => onCancelClick("customer")}
              className='btn btn--small btn--cancel'
            >
              Cancel
            </button>
          </div>
        </Tab>
        <Tab eventKey='DataBase' title='DataBase' className='mt-5'>
          {IntFileds.map((field) => {
            const { fieldType, displayLabel, id } = field;
            return (
              <div key={field.id} className='row mt-3'>
                <label className='col-sm-2 col-form-label'>
                  {displayLabel}
                </label>
                <div className='col-sm-4'>
                  {printField({
                    fieldType,
                    id,
                    selected,
                    onChange,
                    props,
                    toggleEye: 'togglePswd4',
                    option: 'dbOption'
                  })}
                </div>
              </div>
            );
          })}
          <div className='mt-4'>
            <button
              type='button'
              onClick={(e) => {
                onSaveClick(e, 'DataBase');
              }}
              className={`btn btn--small btn--default`}
              disabled={disableDBButton}
            >
              Save
            </button>
            <button
              type='button'
              // onClick={() => onCancelClick("customer")}
              className='btn btn--small btn--cancel'
            >
              Cancel
            </button>
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};
